"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_dom_1 = require("react-router-dom");
var okta_react_1 = require("@okta/okta-react");
var react_query_1 = require("@tanstack/react-query");
var Login_1 = (0, tslib_1.__importDefault)(require("./components/okta/Login"));
var Logout_1 = (0, tslib_1.__importDefault)(require("./components/okta/Logout"));
var Authenticate_1 = (0, tslib_1.__importDefault)(require("./components/okta/Authenticate"));
var ClientSelectWrapper_1 = require("./clientSelect/ClientSelectWrapper");
var config_1 = require("../config");
var routes_1 = require("./routes");
var AuthenticateLoader_1 = (0, tslib_1.__importDefault)(require("./components/AuthenticateLoader"));
var FundManager_1 = require("../components/FundManager");
var reduceRoutePaths = function (accumulator, _a) {
    var paths = _a.paths;
    return accumulator.concat(paths.map(function (path) { return "/".concat(path); }));
};
var client = new react_query_1.QueryClient();
var OktaRoutes = function (_a) {
    var children = _a.children;
    var authState = (0, okta_react_1.useOktaAuth)().authState;
    var isAuthenticated = (authState !== null && authState !== void 0 ? authState : {}).isAuthenticated;
    var isPending = typeof isAuthenticated === 'undefined';
    var ntConfig = (0, config_1.useNTConfig)();
    var _b = ntConfig.MicroFE, defaultPath = _b.defaultPath, applications = _b.applications;
    var validAuthenticatedPaths = (0, react_1.useMemo)(function () { return applications.reduce(reduceRoutePaths, []); }, [applications]);
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: routes_1.routes.login, component: Login_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: routes_1.routes.logout, component: Logout_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: routes_1.routes.authenticate, component: Authenticate_1.default }),
        react_1.default.createElement(okta_react_1.SecureRoute, { exact: true, path: routes_1.routes.fundManager, component: FundManager_1.FundManager }),
        react_1.default.createElement(okta_react_1.SecureRoute, { path: validAuthenticatedPaths },
            react_1.default.createElement(react_query_1.QueryClientProvider, { client: client },
                react_1.default.createElement(ClientSelectWrapper_1.ClientSelectWrapper, null, children))),
        react_1.default.createElement(react_router_dom_1.Route, { render: function () {
                // eslint-disable-next-line no-nested-ternary
                return isAuthenticated ? (react_1.default.createElement(react_router_dom_1.Redirect, { to: defaultPath })) : isPending ? (react_1.default.createElement(AuthenticateLoader_1.default, { text: "Signing In..." })) : (react_1.default.createElement(react_router_dom_1.Redirect, { to: routes_1.routes.login }));
            } })));
};
exports.default = OktaRoutes;
